import React, {Component} from 'react';
import {Dialog, CardActions, DialogActions, Button, DialogTitle, DialogContent} from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import EditIcon from '@material-ui/icons/Edit';
import {
    SimpleForm,
    NumberInput,
    TextInput,
    BooleanInput,
    UPDATE, GET_ONE,
    refreshView as refreshViewAction,
    required,
    number,
    minValue
} from "react-admin";
import laravelJsonServerClient from '../../restClient'
import {connect} from 'react-redux';
import {authorized} from '../../authorized'
import {getChannelName} from '../channels';
import swal from "sweetalert";

const integerValidators = [required(), number(), minValue(0)];

/**
 * Edit the OMS-owned routing fields: priority, min_qty, backorders.
 */
class EditPriorityBtn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            values: {},
            data: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.validate = this.validate.bind(this);
    };

    validate(value) {
        Object.keys(value).forEach(key => {
            if (this.state.values.hasOwnProperty(key) === false || this.state.values[key] !== value[key]) {
                this.setState({values: value});
            }
        });
    }

    fetchData() {
        laravelJsonServerClient(GET_ONE, 'inventory/priority', {id: this.props.record.id}).then(r => {
            this.setState({
                data: r.data ? r.data : [],
            });
        });
    }

    handleSubmit() {
        const values = this.state.values;
        laravelJsonServerClient(UPDATE, 'inventory/priority', {
            id: this.props.record.id,
            data: {
                priority: values.priority,
                min_qty: values.min_qty,
                backorders: values.backorders
            }
        }).then(
            r => {
                if (r.data.result) {
                    this.handleClose();
                    this.props.refreshView();
                } else {
                    this.handleClose();
                    swal(r.data.message || 'Unable to update inventory priority', {title: 'NOTIFY'});
                }
            }
        ).catch((e) => {
            swal(e.message || 'Unable to update inventory priority', {title: 'NOTIFY'});
            console.error(e);
        });
    }

    showModal = () => {
        const record = this.props.record || {};
        this.fetchData();
        this.setState({
            show: true,
            values: {
                priority: record.priority,
                min_qty: record.min_qty,
                backorders: record.backorders
            }
        });
    };

    handleClose = () => {
        this.setState({show: false, data: '', values: {}});
    };

    render() {
        if (authorized.permissions.indexOf('inventory.priority.edit') === -1) {
            return (<span/>);
        }

        let record = this.props.record;
        let actions = [
            <Button
                label="Submit"
                key={'secondary'}
                primary="true"
                variant={"outlined"} color={"secondary"}
                size={"small"}
                startIcon={<SaveIcon/>}
                onClick={this.handleSubmit}>Submit</Button>,
            <Button
                label="Dismiss"
                primary="true"
                key={'primary'}
                size={"small"}
                color={"primary"}
                variant="outlined"
                onClick={this.handleClose}>Dismiss</Button>
        ];

        let buttonEdit = '';
        if (record) {
            buttonEdit = <Button
                label=""
                size="small"
                style={{overflow: 'inherit', color: '#000'}}
                onClick={this.showModal}
                startIcon={<EditIcon/>}>
                Edit
            </Button>
        }

        if (this.state.data !== '') {
            record = this.state.data;
        }

        const title = record.sku
            ? `${record.sku} / ${getChannelName(record.channel_id) || record.channel_id}`
            : 'Inventory Priority';

        return (
            <main>
                {buttonEdit}
                <Dialog
                    bodyClassName={"modal-edit-address"}
                    title={title}
                    actions={actions}
                    modal={true}
                    maxWidth={'sm'}
                    fullWidth={'true'}
                    open={this.state.show}
                    autoScrollBodyContent={true}
                >
                    <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                        {title}
                    </DialogTitle>
                    <DialogContent dividers>
                        <span>
                            <SimpleForm submitOnEnter={false}
                                        defaultValue={record}
                                        save={this.handleSubmit}
                                        validate={this.validate}
                                        toolbar={<CardActions/>} handleSubmit={this.handleClose}
                                        redirect={false}>
                                <TextInput fullWidth={true} disabled source="sku"/>
                                <TextInput fullWidth={true} disabled source="warehouse_name" label="Warehouse"/>
                                <TextInput fullWidth={true} disabled source="sales_channel_name" label="Sales Channel"/>
                                <TextInput fullWidth={true} disabled source="country"/>
                                <NumberInput fullWidth={true} disabled className='customInventoryInput'
                                             source="available_qty" label="Available Qty"/>
                                <NumberInput fullWidth={true} className='customInventoryInput' source="priority"
                                             min={0} step={1} validate={integerValidators}/>
                                <NumberInput fullWidth={true} className='customInventoryInput' source="min_qty"
                                             label="Min Qty" min={0} step={1} validate={integerValidators}/>
                                <BooleanInput fullWidth={true} source="backorders"/>
                            </SimpleForm>
                        </span>
                    </DialogContent>
                    <DialogActions>
                        {actions}
                    </DialogActions>
                </Dialog>
            </main>
        );
    }
}

export default connect(undefined, {refreshView: refreshViewAction})(
    EditPriorityBtn
);
